/* Magnelena product page scripts */
(function () {
  if (window.__mgInit) return; window.__mgInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Main product ---------- */
  function initPdp(el) {
    if (el.__mg) return; el.__mg = true;
    var offers = $$('[data-offer]', el);
    var colors = $$('[data-color]', el);
    var mode = el.dataset.mode;
    var picks = {}; var order = [];
    var atc = $('[data-atc]', el), atcText = $('[data-atc-text]', el), msg = $('[data-msg]', el);
    var qtyInput = $('[data-qty-input]', el);

    function activeOffer() { return $('[data-offer].is-active', el) || offers[0]; }
    function needed() { var o = activeOffer(); return o ? parseInt(o.dataset.total, 10) || 1 : 1; }
    function pickedCount() { return order.length; }

    function render() {
      var o = activeOffer();
      if (o) {
        $('[data-price-now]', el).textContent = o.dataset.now;
        var was = $('[data-price-was]', el), badge = $('[data-price-badge]', el), unit = $('[data-price-unit]', el);
        if (o.dataset.was) { was.textContent = o.dataset.was; was.hidden = false; } else { was.hidden = true; }
        if (o.dataset.badge) { badge.textContent = o.dataset.badge; badge.hidden = false; } else { badge.hidden = true; }
        if (unit) unit.textContent = o.dataset.unit;
      }
      var n = needed();
      while (order.length > n) { var last = order.pop(); picks[last.key]--; }
      colors.forEach(function (c) {
        var k = c.dataset.name; var q = picks[k] || 0;
        c.classList.toggle('is-picked', q > 0);
        var b = $('[data-qty]', c); if (b) b.textContent = '×' + q;
      });
      var pc = $('[data-picked]', el), nd = $('[data-needed]', el);
      if (pc) pc.textContent = pickedCount();
      if (nd) nd.textContent = n;
      if (atcText) {
        var missing = colors.length ? n - pickedCount() : 0;
        var price = o ? ' — ' + o.dataset.now : '';
        if (missing > 0) { atcText.textContent = el.dataset.txtMissing.replace('[n]', missing); atc.classList.add('is-incomplete'); }
        else { atcText.textContent = el.dataset.txtAtc + price; atc.classList.remove('is-incomplete'); }
      }
      // gifts
      var total = n * (parseInt(qtyInput && qtyInput.value, 10) || 1), unlocked = 0;
      $$('[data-gift]', el).forEach(function (g) {
        var on = total >= (parseInt(g.dataset.min, 10) || 0);
        g.classList.toggle('is-unlocked', on); if (on) unlocked++;
        var note = $('.mg-gift__note', g); if (note) note.textContent = on ? note.dataset.on : note.dataset.off;
      });
      var gc = $('[data-gifts-count]', el); if (gc) gc.textContent = unlocked;
    }

    offers.forEach(function (o) {
      o.addEventListener('click', function () { offers.forEach(function (x) { x.classList.remove('is-active'); }); o.classList.add('is-active'); render(); });
    });
    colors.forEach(function (c) {
      c.addEventListener('click', function () {
        if (pickedCount() >= needed()) { c.classList.remove('mg-shake'); void c.offsetWidth; c.classList.add('mg-shake'); return; }
        var k = c.dataset.name; picks[k] = (picks[k] || 0) + 1; order.push({ key: k, id: c.dataset.id }); render();
      });
    });
    var reset = $('[data-reset]', el);
    if (reset) reset.addEventListener('click', function () { picks = {}; order = []; render(); });

    var minus = $('[data-qty-minus]', el), plus = $('[data-qty-plus]', el);
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); render(); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; render(); });
    if (qtyInput) qtyInput.addEventListener('change', render);

    if (atc) atc.addEventListener('click', function () {
      var n = needed(), mult = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (colors.length && pickedCount() < n) {
        var box = $('[data-colors]', el); if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        colors.forEach(function (c) { c.classList.remove('mg-shake'); void c.offsetWidth; c.classList.add('mg-shake'); });
        return;
      }
      var items = [];
      if (mode === 'variant') {
        var byId = {}; order.forEach(function (p) { byId[p.id] = (byId[p.id] || 0) + 1; });
        Object.keys(byId).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: byId[id] * mult }); });
      } else if (mode === 'block') {
        var parts = Object.keys(picks).filter(function (k) { return picks[k] > 0; }).map(function (k) { return k + ' ×' + (picks[k] * mult); });
        var props = {}; props[el.dataset.propName || 'Couleurs'] = parts.join(', ');
        items.push({ id: parseInt(el.dataset.variant, 10), quantity: (el.dataset.lot ? (parseInt(activeOffer().dataset.lots, 10) || 1) : n) * mult, properties: props });
      } else {
        items.push({ id: parseInt(el.dataset.variant, 10), quantity: (el.dataset.lot ? (parseInt(activeOffer().dataset.lots, 10) || 1) : n) * mult });
      }
      $$('[data-upsell]:checked', el).forEach(function (u) { items.push({ id: parseInt(u.value, 10), quantity: 1 }); });
      atc.disabled = true; if (msg) msg.textContent = '';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { window.location.href = root + (el.dataset.after === 'checkout' ? 'checkout' : 'cart'); })
        .catch(function (e) { atc.disabled = false; if (msg) msg.textContent = (e && (e.description || e.message)) || 'Error, inténtalo de nuevo.'; });
    });

    // countdown to midnight
    var cd = $('[data-countdown]', el);
    if (cd) {
      var mins = parseInt(cd.dataset.minutes, 10) || 600, key = 'mgTimer:' + location.pathname, end = 0;
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      var isReload = nav.type === 'reload' || (performance.navigation && performance.navigation.type === 1);
      try { var saved = parseInt(sessionStorage.getItem(key), 10); if (isReload && saved > Date.now()) end = saved; } catch (e) {}
      if (!end) end = Date.now() + mins * 60000;
      try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      var tick = function () {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
        cd.textContent = [h, m, ss].map(function (v) { return (v < 10 ? '0' : '') + v; }).join(':');
      };
      tick(); setInterval(tick, 1000);
    }

    // gallery dots (mobile)
    var track = $('[data-mg-gallery]', el), dots = $$('[data-mg-dots] span', el);
    if (track && dots.length) track.addEventListener('scroll', function () {
      var w = track.firstElementChild ? track.firstElementChild.offsetWidth + 8 : 1;
      var i = Math.round(track.scrollLeft / w);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });

    // stories modal
    var modal = $('[data-modal]', el), body = $('[data-modal-body]', el);
    $$('[data-story]', el).forEach(function (s) {
      s.addEventListener('click', function () {
        var t = $('template', s); if (!t || !modal) return;
        body.innerHTML = ''; body.appendChild(t.content.cloneNode(true));
        var v = $('video', body); if (v) { v.muted = false; v.play && v.play().catch(function () {}); }
        modal.classList.add('is-open'); document.body.style.overflow = 'hidden';
      });
    });
    function closeModal() { if (!modal) return; modal.classList.remove('is-open'); body.innerHTML = ''; document.body.style.overflow = ''; }
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      $('[data-modal-close]', modal).addEventListener('click', closeModal);
    }

    // sticky bar
    var sticky = $('[data-sticky]', el), buy = $('.mg-buy', el);
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buy);
      $('[data-sticky-btn]', sticky).addEventListener('click', function (ev) {
        ev.preventDefault(); var target = $('.mg-offers', el) || buy; target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    render();
  }

  /* ---------- Generic carousels ---------- */
  function initCarousel(c) {
    if (c.__mg) return; c.__mg = true;
    var track = $('[data-track]', c);
    $$('[data-prev],[data-next]', c).forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.firstElementChild; var step = card ? card.offsetWidth + 14 : 300;
        track.scrollBy({ left: b.hasAttribute('data-next') ? step : -step, behavior: 'smooth' });
      });
    });
    $$('.mg-ugc__card video', c).forEach(function (v) {
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } }); }, { threshold: .4 }).observe(v);
    });
  }

  /* ---------- Split slides ---------- */
  function initSlides(s) {
    if (s.__mg) return; s.__mg = true;
    var slides = $$('[data-slide]', s); if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (sl, j) { sl.classList.toggle('is-active', j === i); });
      $$('[data-dot]', s).forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function auto() { clearInterval(timer); var t = parseInt(s.dataset.autoplay, 10); if (t) timer = setInterval(function () { go(i + 1); }, t * 1000); }
    $$('[data-prev]', s).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); auto(); }); });
    $$('[data-next]', s).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); auto(); }); });
    $$('[data-dot]', s).forEach(function (d, j) { d.addEventListener('click', function () { go(j); auto(); }); });
    auto();
  }

  /* ---------- Bought together ---------- */
  function initFbt(f) {
    if (f.__mg) return; f.__mg = true;
    var items = $$('[data-fbt-item]', f), total = $('[data-fbt-total]', f), btn = $('[data-fbt-add]', f);
    var fmt = function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; };
    function upd() {
      var t = 0; items.forEach(function (it) { if (it.classList.contains('is-on')) t += parseInt(it.dataset.price, 10); });
      if (total) { var mf = f.dataset.moneyFormat || ''; var amt = (t / 100).toFixed(2); if (/comma/.test(mf)) amt = amt.replace('.', ','); total.textContent = mf ? mf.replace(/<[^>]*>/g, '').replace(/\{\{\s*amount[^}]*\}\}/, amt) : fmt(t); }
    }
    items.forEach(function (it) { $('[data-fbt-toggle]', it).addEventListener('click', function () { it.classList.toggle('is-on'); upd(); }); });
    if (btn) btn.addEventListener('click', function () {
      var list = items.filter(function (it) { return it.classList.contains('is-on'); }).map(function (it) { return { id: parseInt(it.dataset.id, 10), quantity: 1 }; });
      if (!list.length) return; btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function () { btn.disabled = false; });
    });
    upd();
  }

  function initAll() {
    $$('[data-mg-pdp]').forEach(initPdp);
    $$('[data-mg-carousel]').forEach(initCarousel);
    $$('[data-mg-slides]').forEach(initSlides);
    $$('[data-mg-fbt]').forEach(initFbt);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
